import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";

export default function About() {
    const { get } = useContent();
    return (
        <div className="content-page" data-testid="about-page">
            <div className="eyebrow" style={{ marginBottom: 12 }}>{get("about.eyebrow", "Our Story")}</div>
            <h1>{get("about.title", "A short list, held to a standard.")}</h1>
            <p className="lede">{get("about.lede", "")}</p>

            <img
                src={get("about.image", "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?auto=format&fit=crop&w=2000&q=80")}
                alt=""
                style={{ width: "100%", height: 480, objectFit: "cover", margin: "32px 0" }}
            />

            <section>
                <h2>{get("about.section_1_title", "Only what earns the rack.")}</h2>
                <p>{get("about.section_1_body", "")}</p>
            </section>

            <section>
                <h2>{get("about.section_2_title", "Circular by design.")}</h2>
                <p>{get("about.section_2_body", "")}</p>
            </section>

            <section>
                <h2>{get("about.section_3_title", "Considered, not curated to death.")}</h2>
                <p>{get("about.section_3_body", "")}</p>
            </section>

            <div style={{ marginTop: 40, display: "flex", gap: 12, flexWrap: "wrap" }}>
                <Link to="/shop" className="btn">Shop The Edit</Link>
                <Link to="/sell" className="btn btn-outline">Sell With Us</Link>
            </div>
        </div>
    );
}
